import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { flatten } from 'lodash';
import { DamageReport } from '../../models/damagereport';
import { BaseService, IServiceUrlConfig } from '../base/base.service';

@Injectable({
  providedIn: 'root',
})
export class DamageReportService extends BaseService<DamageReport> {
  public override http: HttpClient;

  constructor() {
    super(inject(HttpClient), DamageReport);
  }

  protected getServiceUrl(entityId?: string, serviceUrlConfig?: IServiceUrlConfig): string {
    let url = ['damagereport'];
    if (serviceUrlConfig && serviceUrlConfig.path) {
      url = flatten([url, serviceUrlConfig.path]);
    }
    return this.apiStrategy.getServiceUrl(url);
  }
}
